import React from 'react'
import PropTypes from 'prop-types'
import { KeyboardDatePicker } from '@material-ui/pickers'
import moment from 'moment'

import rangeDateSectionStyles from './css/rangeDateSectionStyles'

const RangeDateSection = ({ initialDate, finalDate, setInitialDate, setFinalDate }) => {
  const classes = rangeDateSectionStyles()

  return (
    <div className={classes.datesContainer}>
      <KeyboardDatePicker
        fullWidth
        disableToolbar
        variant="inline"
        format="DD/MM/yyyy"
        margin="normal"
        id="initial-date"
        label="Inicio"
        value={initialDate}
        onChange={setInitialDate}
        KeyboardButtonProps={{
          'aria-label': 'initial-date',
        }}
        inputVariant="outlined"
        className={classes.datePicker}
      />
      <KeyboardDatePicker
        disableToolbar
        fullWidth
        variant="inline"
        format="DD/MM/yyyy"
        margin="normal"
        id="final-date"
        label="Fin"
        value={finalDate}
        onChange={setFinalDate}
        KeyboardButtonProps={{
          'aria-label': 'final-date',
        }}
        inputVariant="outlined"
      />
    </div>
  )
}

RangeDateSection.propTypes = {
  initialDate: PropTypes.objectOf(moment),
  finalDate: PropTypes.objectOf(moment),
  setInitialDate: PropTypes.func,
  setFinalDate: PropTypes.func,
}

RangeDateSection.defaultProps = {
  initialDate: '',
  finalDate: '',
  setInitialDate: () => {},
  setFinalDate: () => {},
}

export default RangeDateSection
